function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget
        .closest("details, details-custom")
        .hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector("input");
    this.startingValue = this.input.value;
    this.input.dataset.starting = this.startingValue;

    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );

    this.input.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        event.preventDefault(); // Prevent the default "Enter" behavior
        event.stopImmediatePropagation(); // Prevent other event listeners from receiving the event

        //remove focus from input
        this.input.blur();
      }
    });

    this.input.addEventListener("input", (event) => {
      this.input.dataset.starting = this.startingValue;
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json", method = "POST") {
  return {
    method: method,
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

// https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c?permalink_comment_id=3141993
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`,
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");

    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    const summaryElements = this.mainDetailsToggle.querySelectorAll("summary");
    summaryElements.forEach((summary) =>
      summary.setAttribute("aria-expanded", false),
    );

    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById("header-group");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide(e) {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      if (this.hasAttribute("data-share") && navigator.share) {
        //share is available and is share modal
        var title = this.dataset.title;
        var desc = this.dataset.desc;
        var url = this.dataset.url;

        return navigator
          .share({
            title: title,
            text: desc,
            url: url,
          })
          .then(() => console.log("Successful share"))
          .catch((error) => console.log("Error sharing", error));
      }

      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    if ("autoplay" in this.dataset) {
      this.setupIntersectionObserver();
    }

    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    if ("pauseAll" in this.dataset) {
      //default behavior - dont pause all other vids
      window.pauseAllMedia();
    }
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      var media = content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );

      media.play(); //play for ios

      media.addEventListener("canplaythrough", () => {
        //video
        media.play(); //play for ios

        const playing_event = new Event("playing");
        this.dispatchEvent(playing_event);
      });

      if (focus) deferredElement.focus();
    }
  }

  setupIntersectionObserver() {
    if ("IntersectionObserver" in window) {
      var lazyMediaObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((media) => {
          if (media.isIntersecting) {
            this.loadContent(false);
            lazyMediaObserver.unobserve(this);
          }
        });
      });
      //TODO - product thumbnail on mobile, no autoplay
      lazyMediaObserver.observe(this);
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    const slider = this.querySelector(`[id^="Slider-"]`);
    if (!slider) {
      return;
    }
    this.init();
  }
  init() {
    const id = this.dataset.sliderId;
    if (id && id != "") {
      //slider within a slider
      this.slider = this.querySelector(`[id^="Slider-${id}"]`);
      this.sliderItems = this.querySelectorAll(`[id^="Slide-${id}"]`);
      this.sliderControlWrapper = this.querySelector(`#slider-buttons--${id}`);
    } else {
      this.slider = this.querySelector(`[id^="Slider-"]`);
      this.sliderItems = this.querySelectorAll(`[id^="Slide-"]`);
      this.sliderControlWrapper = this.querySelector(".slider-buttons");
    }

    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.sliderControlWrapper.querySelector(
      'button[name="previous"]',
    );
    this.nextButton = this.sliderControlWrapper.querySelector(
      'button[name="next"]',
    );
    this.sliderFirstItemNode = this.slider.querySelector(this.getSlideClass());

    if (!this.slider || !this.nextButton) return;

    if (this.sliderControlWrapper) {
      this.sliderControlLinksArray = Array.from(
        this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
      );
      this.sliderControlLinksArray.forEach((link) =>
        link.addEventListener("click", this.linkToSlide.bind(this), false),
      );
    }

    this.mobileQuery = window.matchMedia("(max-width: 749px)");

    //desktop dragable https://bit.ly/3zCGKzg
    this.mouseDown = false;
    this.mouseMove = false;
    this.startX;
    this.initialLeft;
    var velX = 0;
    var momentumID;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.handleSlide.bind(this));

    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));

    //Drag listeners
    this.slider.addEventListener("mousemove", this.onDrag.bind(this));
    this.slider.addEventListener("mousedown", this.startDragging.bind(this));
    this.slider.addEventListener(
      "mouseup",
      this.stopDragging.bind(this),
      false,
    );
    //THIS IS CAUSING ISSUES FOR SLIDER IN SLIDER - triggers mouseup on parent slider
    this.slider.addEventListener(
      "mouseleave",
      this.handleMouseLeave.bind(this),
      false,
    );

    this.slider.classList.add("slider--loaded");
  }

  getSlideClass() {
    return ".slider__slide"; //take slider class outside constructor so it can be set within home-banner
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (this.mouseDown) return; //dont update until mouse is released

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }
    //handle dot slider buttons
    this.sliderControlButtons = this.sliderControlWrapper.querySelectorAll(
      ".slider-counter__link",
    );

    if (this.sliderControlButtons.length > 0) {
      this.sliderControlButtons.forEach((link) => {
        link.classList.remove("slider-counter__link--active");
        link.removeAttribute("aria-current");
      });

      var current_slide = this.sliderControlButtons[this.currentPage - 1];

      if (this.dataset.type == "product") {
        //product slider has slides hidden depending on colour

        //determine visible
        const current_color = this.closest(".product").dataset.currentColor;

        //need to select non-color slides
        let other_colors = ["gold", "silver", "rose"];

        var non_color_items_selector = other_colors.map((color) => {
          return `:not([data-href*="${color}"])`;
        });

        //gold and rose gold must be different
        var dot_css =
          current_color == "gold"
            ? `.product[data-current-color*="${current_color}"] .product-dot[data-href*="${current_color}"]:not([data-href*="rosegold"])`
            : `.product[data-current-color*="${current_color}"] .product-dot[data-href*="${current_color}"]`;

        var visible_slides = this.querySelectorAll(
          `${dot_css}, .product-dot${non_color_items_selector.join("")}`,
        );
        var visible_total = visible_slides.length;
        current_slide = visible_slides[(this.currentPage - 1) % visible_total];
      }

      current_slide?.classList.add("slider-counter__link--active");
      current_slide?.setAttribute("aria-current", true);
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  handleSlide(e) {
    e.stopImmediatePropagation();
    e.stopPropagation();

    this.update();
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();

    this.slider.classList.remove("no-snap");
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  startDragging(e) {
    console.log("started dragging");
    if (this.mobileQuery.matches) {
      //disable on mobile for slider within a slider controls
      return;
    }

    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1; //set current before drag starts
    this.mouseDown = true;
    this.startX = e.pageX - this.slider.offsetLeft;
    this.initialLeft = this.slider.scrollLeft;
    this.cancelMomentumTracking();
  }
  onDrag(event) {
    event.preventDefault();
    if (!this.mouseDown) {
      return;
    }

    this.slider.classList.add("dragging");
    this.slider.classList.add("no-snap");

    const x = event.pageX - this.slider.offsetLeft;
    const walk = (x - this.startX) * 1.4; //scroll-fast
    var prevScrollLeft = this.slider.scrollLeft;

    this.slider.scrollLeft = this.initialLeft - walk;
    this.velX = this.slider.scrollLeft - prevScrollLeft;
  }
  stopDragging(event) {
    if (this.mobileQuery.matches) {
      // disable on mobile for slider within a slider controls
      return;
    }
    this.mouseDown = false;

    this.beginMomentumTracking();
  }
  handleMouseLeave() {
    this.mouseDown = false;
    this.slider.classList.remove("dragging");
  }

  //https://codepen.io/loxks/details/KKpVvVW
  beginMomentumTracking() {
    this.cancelMomentumTracking();
    this.momentumID = requestAnimationFrame(this.momentumLoop.bind(this));
  }
  cancelMomentumTracking() {
    cancelAnimationFrame(this.momentumID);
  }
  momentumLoop() {
    this.slider.scrollLeft += this.velX;
    this.velX *= 0.95;
    if (Math.abs(this.velX) > 0.5) {
      this.momentumID = requestAnimationFrame(this.momentumLoop.bind(this));
    } else {
      this.slider.classList.remove("dragging"); //allow clicking of links
    }
  }

  linkToSlide(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    var next_slide =
      this.sliderControlLinksArray.indexOf(event.currentTarget) +
      1 -
      this.currentPage;
    var clicked_control_distance =
      this.sliderFirstItemNode.clientWidth * next_slide;
    var slideScrollPosition = this.slider.scrollLeft + clicked_control_distance;

    if (event.currentTarget.classList.contains("product-dot")) {
      var media_id = event.currentTarget.dataset.mediaId;
      var slider_thumb = this.querySelector(
        `.product__media-item[data-media-id="${media_id}"]`,
      );
      slideScrollPosition = slider_thumb.offsetLeft;
    }

    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.enableSliderLooping = true;

    this.sliderFirstItemNode = this.slider.querySelector(this.getSlideClass());
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  getSlideClass() {
    return ".slideshow__slide"; //take slider class outside constructor so it can be set within home-banner
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this),
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    // this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute("disabled");

    // if (!this.sliderControlButtons.length) return;

    // this.sliderControlButtons.forEach(link => {
    //   link.classList.remove('slider-counter__link--active');
    //   link.removeAttribute('aria-current');
    // });
    // this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    // this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(this.getSlideClass()).clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

//Global to not re-enstatite multiple sliders
class GenericSlider extends SlideshowComponent {
  constructor() {
    super();
  }

  getSlideClass() {
    return ".slider__slide";
  }
}

customElements.define("generic-slider", GenericSlider);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.closestUpsell = this.closest("cart-upsell");
    this.preOrder = this.dataset.preorder == "true";
    this.bundle = this.hasAttribute("data-bundle");
    this.init();
    this.addEventListener("change", this.onVariantChange);
  }

  init() {
    //hide unavailable options
    this.updateOptions();
    this.updateMasterId();
    this.updateUnavailableOptions();
  }

  onVariantChange() {
    if (this.bundle) {
      //bundle products have their options matched
      //change hidden button
      let first_colour_value = this.querySelector(
        "fieldset[data-colour='true'] input:checked",
      ).value;
      let other_colours = Array.from(
        this.querySelectorAll(
          "fieldset[data-colour='true']:not(:first-of-type)",
        ),
      );

      other_colours.forEach((fieldset) => {
        var matching_option = fieldset.querySelector(
          `input[value="${first_colour_value}"]`,
        );
        if (matching_option) {
          matching_option.checked = true;
        }
      });
    }
    this.updateOptions();
    this.updateMasterId();
    this.updateUnavailableOptions();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateColorValue();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateProductUpsell();
      this.updateAfterpay();
    }

    document.body.dispatchEvent(
      new CustomEvent("variantChange", {
        detail: {
          currentVariant: this.currentVariant,
        },
      }),
    );

    if (this.closestUpsell) {
      this.closestUpsell.dispatchEvent(
        new CustomEvent("variantChange", {
          detail: {
            currentVariant: this.currentVariant,
          },
        }),
      );
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateUnavailableOptions() {
    if (
      !this.currentVariant ||
      !this.variantData ||
      this.hasAttribute("data-replen")
    )
      return;

    //loop through all variants and return unavailable
    this.unavailableOptions = new Set();

    this.variantData.forEach((variant) => {
      //only want unavailable
      if (!variant.available) {
        //find option that is no
        if (variant.options.length == 1) {
          this.unavailableOptions.add(variant.options[0]);
        } else {
          //for multiple options, check each one to see if it is current selected (matching) and all options
          for (let i = 0; i < variant.options.length; i++) {
            const option = variant.options[i];
            if (option == this.currentVariant.options[i]) {
              // add other options to prevent users
              for (let j = 0; j < variant.options.length; j++) {
                if (j == i) continue; //skip matching option (already added
                const unavailable_option = variant.options[j];
                this.unavailableOptions.add(unavailable_option);
              }
            }
          }
        }
      }
    });

    const all_options = this.querySelectorAll('input[type="radio"]');

    all_options.forEach((option_el) => {
      let value = option_el.value;
      if (this.unavailableOptions.has(value) && !option_el.checked) {
        //unavailable option that is not currently selected
        option_el.disabled = true;
      } else {
        option_el.disabled = false;
      }
    });
  }

  updateColorValue() {
    //set the top product container color value. uses css to hide/show slides that contain value
    let product_form = document.querySelector(
      `#ProductContainer-${this.dataset.section}`,
    );

    if (!product_form) return;

    const color_index = product_form.dataset.baseColorIndex;

    if (!color_index) return;

    let selected_color = this.currentVariant.options[parseInt(color_index)];

    if (!selected_color) return;

    product_form.dataset.currentColor = selected_color.toLowerCase();

    //update slider (for dots)
    const product_el = this.closest(".product");
    const product_slider = product_el?.querySelector("slider-component");

    if (!product_slider) return;

    product_slider.update();
  }

  updateMedia() {
    //highlight featured image
    var featured_media_id = this.currentVariant.featured_media?.id;
    if (!featured_media_id) return;
    var feature_image = document.querySelector(
      `.product__media-item[data-media-id*="${featured_media_id}"]`,
    );
    if (feature_image) {
      //highlight featured image
      const mobile_query = window.matchMedia("(max-width: 749px)");

      if (mobile_query.matches) {
        //mobile scroll into view
        var gallery_slider = document.querySelector(
          '[id^="GalleryViewer"] .slider',
        );
        // var matching_slider_control = gallery_slider.querySelector(`.slider-counter__link`)

        gallery_slider.scrollTo({
          left: feature_image.offsetLeft,
        });
      } else {
        //desktop set order
        var current_featured_image = document.querySelector(
          ".product__media-item.featured",
        );
        current_featured_image?.classList.remove("featured");

        feature_image.classList.add("featured");
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      //if a product upsell is selected, use items array style
      const input =
        productForm.querySelector('input[name="id"]') ||
        productForm.querySelector('input[name="items[0][id]"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    //TODO - multi currency
    var money = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
    });

    var on_sale = false;
    var available = this.currentVariant.available;

    const price_cents = this.currentVariant.price;
    const compare_cents = this.currentVariant.compare_at_price;

    if (compare_cents && compare_cents > price_cents) {
      on_sale = true;
    }

    const price_container = document.getElementById(
      `price-${this.dataset.section}`,
    );

    const price_els = price_container.querySelectorAll(
      ".price__regular .price-item.price-item--regular, .price__sale .price-item.price-item--sale",
    );
    const compare_el = price_container.querySelector(
      ".price__sale .price-item.price-item--regular",
    );

    if (price_els.length > 0) {
      price_els.forEach((el) => {
        el.innerHTML = money.format(price_cents / 100);
      });
    }

    if (compare_el && compare_cents) {
      compare_el.innerHTML = money.format(compare_cents / 100);
    }

    const price_wrapper = price_container.querySelector(".price"); //used to show sale and OOS

    if (price_wrapper) {
      price_wrapper.classList.remove("price--sold-out");
      price_wrapper.classList.remove("price--on-sale");

      if (!available) {
        price_wrapper.classList.add("price--sold-out");
      }
      if (on_sale) {
        price_wrapper.classList.add("price--on-sale");
      }
    }

    this.inventoryScarcity(price_container);

    if (price_container) price_container.classList.remove("visibility-hidden");
    this.toggleAddButton(
      !this.currentVariant.available,
      window.variantStrings.soldOut,
    );
  }

  inventoryScarcity(container) {
    const scarcity_el = container.querySelector(
      '.price--scarcity [type="application/json"]',
    );
    if (!scarcity_el) return;
    this.scarcityData =
      this.scarcityData ||
      JSON.parse(
        container.querySelector('.price--scarcity [type="application/json"]')
          .textContent,
      );

    if (!this.scarcityData || !this.currentVariant) return;

    const scarcity_copy_el = container.querySelector(".price--scarcity span");
    const variant_inventory =
      this.scarcityData.variant_inventory[this.currentVariant.id];

    if (
      variant_inventory &&
      variant_inventory.policy != "continue" &&
      variant_inventory.management == "shopify"
    ) {
      let scarcity_copy = "";
      //loop over limits to find lowest band, save copy
      for (let i = 0; i < this.scarcityData.limits.length; i++) {
        const limit_item = this.scarcityData.limits[i];
        if (limit_item.copy == "") continue;
        if (
          variant_inventory.quantity < limit_item.limit &&
          variant_inventory.quantity > 0
        ) {
          scarcity_copy = limit_item.copy.replace(
            "[amount]",
            variant_inventory.quantity,
          );
          break;
        }
      }
      scarcity_copy_el.innerHTML = scarcity_copy;
    }
  }

  updateProductUpsell() {
    const upsell_container = document.getElementById(
      `product-upsell--${this.dataset.section}`,
    );

    if (!upsell_container || !this.currentVariant) return;

    this.setUpsellImage(upsell_container);
  }

  setUpsellImage(container) {
    let color_index = container.dataset.colorIndex;

    if (!color_index) return;

    let current_color =
      this.currentVariant.options[parseInt(color_index)]?.toLowerCase();

    container.dataset.colorCurrent = current_color; //set this here to be used by product-upsell element

    //only change image that have variant featured media
    const upsell_items = container.querySelectorAll(
      `.product-upsell__item[data-${current_color}]`,
    );

    upsell_items.forEach((item) => {
      let variant_image = item.dataset[current_color];
      item.querySelector("img").src = variant_image;
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton =
      productForm.querySelector("#mwAddToCart") ||
      productForm.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector("span");
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");

      if (this.preOrder) {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else if (text) {
        addButtonText.textContent = text;
      }
    } else {
      addButton.removeAttribute("disabled");
      if (this.preOrder) {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateAfterpay() {
    const afterpay_el = document.querySelector(
      `#product-afterpay--${this.dataset.section}`,
    );

    if (!afterpay_el) return;

    let installments = afterpay_el.dataset.installments;

    var increment_price = this.currentVariant.price / parseInt(installments);

    afterpay_el.querySelector(".js-afterpay-price").innerHTML =
      Shopify.formatMoney(increment_price);
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

// Variant links are used for swatches to go to corresponding products
class VariantLinks extends HTMLElement {
  constructor() {
    super();
    this.parent_container = this.closest(".product__info-container");
    this.link_products = JSON.parse(
      this.querySelector("#variant-links-data").innerText,
    );
    this.tone = this.dataset.initialTone.toLowerCase();

    this.addEventListener("change", this.onVariantLinkChange.bind(this));

    if (!this.parent_container) return;

    //get all variant-radios
    this.variant_radios =
      this.parent_container.querySelectorAll("variant-radios");

    //attach change event to all radios
    this.variant_radios.forEach((radio) => {
      radio.addEventListener("change", this.onVariantChange.bind(this));
    });

    //http://127.0.0.1:9292/products_preview?preview_key=0fedfedc985e65a6e1d12a5033c603f4
  }

  onVariantChange(event) {
    this.tone = event.target.value.toLowerCase();
  }

  onVariantLinkChange(event) {
    event.preventDefault();
    var target = event.target;
    if (!target) return;

    target.checked = false; //prevent being checked for when going history back

    var page_link = target.value;
    var product_id = target.dataset.productId;

    if (!page_link) return;

    window.location = page_link + this._getVariantParam(product_id);
  }

  // returns matching ton within link_products
  _getVariantParam(id) {
    //?variant=42870826991797
    var match_product = this.link_products.find((product) => {
      return product.id == id;
    });

    if (!match_product) return "";

    var match_variant = match_product.variants.find((variant) => {
      return variant.title.toLowerCase().includes(this.tone);
    });

    return match_variant ? `?variant=${match_variant.id}` : "";
  }
}
customElements.define("variant-links", VariantLinks);

class LazyVideo extends HTMLElement {
  constructor() {
    super();

    this.video_el = this.querySelector("video.lazy");
    this.attachIntersectionObserver();

    this.addEventListener("click", this.playVideo.bind(this));
  }

  attachIntersectionObserver() {
    const responsive = this.dataset.responsive == "true";
    const options = {
      root: null,
      threshold: 0.99,
    };
    //https://web.dev/lazy-loading-video/
    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function (
        entries,
        observer,
      ) {
        entries.forEach((video) => {
          if (video.isIntersecting) {
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              if (
                typeof videoSource.tagName === "string" &&
                videoSource.tagName === "SOURCE"
              ) {
                if (responsive) {
                  const mobile_query = window.matchMedia("(max-width: 749px)");

                  if (mobile_query.matches && videoSource.dataset.mobile) {
                    //mobile
                    videoSource.src = videoSource.dataset.src;
                  } else if (
                    !mobile_query.matches &&
                    videoSource.dataset.desktop
                  ) {
                    //desktop
                    videoSource.src = videoSource.dataset.src;
                  }
                } else {
                  videoSource.src = videoSource.dataset.src;
                }
              }
            }

            video.target.load();
            video.target.classList.remove("lazy");
            video.target.classList.add("lazyloaded");

            if (video.target.hasAttribute("autoplay")) {
              video.target.play();
            }

            lazyVideoObserver.unobserve(video.target);
          }
        });
      }, options);

      lazyVideoObserver.observe(this.video_el);
    }
  }

  playVideo() {
    if (this.video_el.classList.contains("playing")) {
      this.video_el.classList.remove("playing");
      this.video_el.classList.add("paused");
      this.video_el.pause();
    } else if (this.video_el.classList.contains("paused")) {
      this.video_el.classList.remove("paused");
      this.video_el.classList.add("playing");
      this.video_el.play();
    } else {
      const responsive = this.dataset.responsive == "true";
      for (var source in this.video_el.children) {
        var videoSource = this.video_el.children[source];
        if (
          typeof videoSource.tagName === "string" &&
          videoSource.tagName === "SOURCE"
        ) {
          if (responsive) {
            const mobile_query = window.matchMedia("(max-width: 749px)");

            if (mobile_query.matches && videoSource.dataset.mobile) {
              //mobile
              videoSource.src = videoSource.dataset.src;
            } else if (!mobile_query.matches && videoSource.dataset.desktop) {
              //desktop
              videoSource.src = videoSource.dataset.src;
            }
          } else {
            videoSource.src = videoSource.dataset.src;
          }
        }
      }

      this.video_el.load();
      this.video_el.classList.remove("lazy");
      this.video_el.classList.add("lazyloaded");

      this.video_el.classList.add("playing");

      this.video_el.play();
    }
  }
}

customElements.define("lazy-video", LazyVideo);
